import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { PROCEDURE_TYPE } from '../../../configs';
import { setApplicant, setFields } from '../../../utils/utils';
import { searchInfoByParamClear } from '../actions';
import { getInfoData } from '../reducer';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { getLegalEntityName, localeFormatter } from '../../../utils/formatters';

export default function SearchInformationBlock(props) {
  const {
    prefix,
    procedure,
    setValue,
    types,
  } = props;
  const {
    infoList,
    startInfoSearch,
    loadingInfoList,
    searchInfoType,
  } = useSelector(getInfoData);
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  useEffect(() => onClear, []);

  const onClear = () => {
    dispatch(searchInfoByParamClear());
  };

  const onSelectApplicant = carrier => {
    if (carrier === undefined) {
      return;
    }
    setValue('applicant.isMatch', false);
    setApplicant(carrier, setValue);

    if ([PROCEDURE_TYPE.PROCEDURE_1227_2, PROCEDURE_TYPE.PROCEDURE_1227_4, PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_3].includes(procedure)) {
      if (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5) {
        const fields1 = [
          'carriage_contract_number',
          'carriage_contract_effective_date',
          'carriage_contract_expiration_date',
          'driver_license_series',
          'driver_license_number',
          'driver_license_issue_date',
          'driver_license_expiration_date',
        ];
        setFields(carrier, prefix, fields1, setValue);
      }
    }
    const fields2 = [
      'effective_date',
      'expiration_date',
    ];
    setFields(carrier, prefix, fields2, setValue);

    if (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3) {
      const fields3 = [
        'web_site',
        'software_names',
        'database_address',
        'server_address',
        'order_receiving_methods',
      ];
      setFields(carrier, prefix, fields3, setValue);
    }
  };

  const onSelectVehicle = item => {
    if (item === undefined) {
      return;
    }
    const fields4 = [
      'vehicle_brand',
      'vehicle_model',
      'vehicle_year',
      'vehicle_color',
      'vehicle_lpn',
      'vehicle_vin',
      'vehicle_registration_number',
      'vehicle_registration_issue_date',
      'ecology_class',
      'applicant_car_cd_file',
      'car_photo_file',
      'has_special_lifting_device',
      'ownership_contract_number',
      'ownership_type',
      'ownership_contract_effective_date',
      'ownership_contract_expiration_date',
      'ownership_contract_files',
    ];
    setFields(item, prefix, fields4, setValue);
  };

  if (!startInfoSearch || !types.includes(searchInfoType)) {
    return null;
  }

  const renderItems = (item, index) => {
    if (['vehicle_lpn', 'vehicle_vin'].includes(searchInfoType)) {
      return (
        <div key={index} className="search-information-data-row">
          <div className="name-block" title={item.full_name}>
            {index + 1}.{localeFormatter('user.type.short', item?.legal_entity_type)} ГРЗ: {item?.vehicle_lpn || ''} VIN: {item.vehicle_vin || ''} Марка: {item.vehicle_brand || ''} Модель: {item.vehicle_model || ''}
            {item?.registry_vehicle ? ` • ${getLegalEntityName(item.registry_vehicle)}` : ''}
          </div>
          <div className="use-button" onClick={() => onSelectVehicle(item)}>Использовать</div>
        </div>
      );
    }
    return (
      <div key={index} className="search-information-data-row">
        <div className="name-block" title={item.full_name}>
          {index + 1}. {localeFormatter('user.type.short', item?.legal_entity_type)} {getLegalEntityName(item)} ИНН: {item?.inn || ''} ОГРН: {item.ogrn || ''}
        </div>
        <div className="use-button" onClick={() => onSelectApplicant(item)}>Использовать</div>
      </div>
    );
  };

  return (
    <div className={classNames('search-information-block mt-3', { 'not-found': !infoList?.length }, { loading: loadingInfoList })}>
      <div className="search-information-icon">
        <Icons customIcon width={24} height={24} icon="notification-circle" />
      </div>
      <div className="search-information-content">
        <div className="search-information-header">
          <div className="search-information-label">Результат поиска</div>
          {infoList?.length ? (<div className="search-information-count">{formatMessage({ id: 'info.search.count' }, { count: infoList?.length || 0 })}</div>) : null}
          <div className="search-information-close" onClick={onClear}>
            <Icons customIcon width={24} height={24} icon="close" />
          </div>
        </div>
        {loadingInfoList ? (
          <div className="search-information-loader">
            <div className="search-information-loader-line" />
          </div>
        ) : (
          <div className="search-information-data custom-scroll-theme">
            {infoList?.length ? infoList.map(renderItems) : <div className="search-information-not-found">По вашему запросу ничего не найдено</div>}
          </div>
        )}
      </div>
    </div>
  );
}
